export default "__VITE_ASSET__CYMFfBen__"